import { gql } from '@apollo/client';

export const START_GOAL_QUESTIONNAIRE = gql`
    mutation START_QUESTIONNAIRE($productID: String) {
        startOver(productGroup: $productID) {
            nextQuestionnaire {
                id
                metaData {
                    questionType
                    question
                    questionDesc
                    validationMsg
                }
                answers {
                    id
                    label
                }
            }
            selectedQuestionnaire {
                questionId
                answers {
                    id
                }
            }
            sessionId
            stage
        }
    }
`;
